// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import { ServerDebugInfoFragmentDoc } from "../DebugInfo/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ServerSettingsQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type ServerSettingsQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    name: string;
    humanId: string;
    permittedToEdit: boolean;
    permittedToRemove: boolean;
    retentionInDays: number;
    lastReceivedSnapshotAt?: number | null;
    lastTestSnapshotAt?: number | null;
    lastSnapshotSubmitter?: string | null;
    duplicateSnapshotReceivedAt?: number | null;
    displaySystemType?: string | null;
    systemScope?: string | null;
    systemId?: string | null;
    clusterId?: string | null;
    postgresVersion?: string | null;
    organization: {
      __typename?: "Organization";
      id: string;
      slug: string;
      planInfo: {
        __typename?: "OrganizationPlanInfo";
        id: string;
        subscriptionPlanName: string;
      };
    };
    latestStats?: {
      __typename?: "PostgresServerStats";
      pgStatStatementsDealloc?: number | null;
      pgStatStatementsReset?: number | null;
    } | null;
  };
  getDatabases: Array<{
    __typename?: "Database";
    id: string;
    datname?: string | null;
    queryCount: number;
    tableCount: number;
    connectionLimit?: number | null;
    encoding?: string | null;
    collate?: string | null;
    hidden: boolean;
    legacyDefault: boolean;
    ownerPostgresRole?: {
      __typename?: "PostgresRole";
      id: string;
      name: string;
    } | null;
  }>;
  hiddenDatabases: Array<{
    __typename?: "Database";
    id: string;
    datname?: string | null;
  }>;
};

export const ServerSettingsDocument = gql`
  query ServerSettings($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      name
      humanId
      permittedToEdit
      permittedToRemove
      retentionInDays
      organization {
        id
        slug
        planInfo {
          id
          subscriptionPlanName
        }
      }
      ...ServerDebugInfo
    }
    getDatabases(serverId: $serverId, hidden: false) {
      id
      datname
      queryCount
      tableCount
      connectionLimit
      encoding
      collate
      hidden
      legacyDefault
      ownerPostgresRole {
        id
        name
      }
    }
    hiddenDatabases: getDatabases(serverId: $serverId, hidden: true) {
      id
      datname
    }
  }
  ${ServerDebugInfoFragmentDoc}
`;

/**
 * __useServerSettingsQuery__
 *
 * To run a query within a React component, call `useServerSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerSettingsQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useServerSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ServerSettingsQuery,
    ServerSettingsQueryVariables
  > &
    (
      | { variables: ServerSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ServerSettingsQuery, ServerSettingsQueryVariables>(
    ServerSettingsDocument,
    options,
  );
}
export function useServerSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServerSettingsQuery,
    ServerSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ServerSettingsQuery, ServerSettingsQueryVariables>(
    ServerSettingsDocument,
    options,
  );
}
// @ts-ignore
export function useServerSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ServerSettingsQuery,
    ServerSettingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  ServerSettingsQuery,
  ServerSettingsQueryVariables
>;
export function useServerSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerSettingsQuery,
        ServerSettingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  ServerSettingsQuery | undefined,
  ServerSettingsQueryVariables
>;
export function useServerSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServerSettingsQuery,
        ServerSettingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServerSettingsQuery,
    ServerSettingsQueryVariables
  >(ServerSettingsDocument, options);
}
export type ServerSettingsQueryHookResult = ReturnType<
  typeof useServerSettingsQuery
>;
export type ServerSettingsLazyQueryHookResult = ReturnType<
  typeof useServerSettingsLazyQuery
>;
export type ServerSettingsSuspenseQueryHookResult = ReturnType<
  typeof useServerSettingsSuspenseQuery
>;
export type ServerSettingsQueryResult = Apollo.QueryResult<
  ServerSettingsQuery,
  ServerSettingsQueryVariables
>;
